import { StoreExt } from '@utils/reactExt'
import { observable, action, computed, runInAction } from 'mobx'
import { IMedia } from './type'

export class MediaStore extends StoreExt {
    @observable
    mediaData: IMedia[] = []

    @observable
    companyId: number

    @action
    setCompanyId = id => {
        this.companyId = id
    }
    @action
    getAllMedia = async () => {
        const data = await this.api.media.getAllMedia()
        runInAction(() => {
            this.mediaData = data
            this.mediaData = this.mediaData.filter(i => i.isActive)
        })
    }
    @action
    deleteMediaDocument = async (id: number) => {
        await this.api.media.deleteMediaDocument(id)
        runInAction(() => {
            this.mediaData = [...this.mediaData.filter(i => i.id !== id)]
        })
    }
    insertMediaDocument = async (name: string, companyId: number, fileByte: string, mediaType?: number) => {
        const newMedia: IMedia = {
            name: name,
            companyId: companyId,
            fileByte: fileByte,
            isActive: true,
            id: 0,
            type: mediaType
        }
        const res = await this.api.media.insertMediaDocument(newMedia)
        runInAction(() => {
            if (res.id !== 0) {
                this.mediaData.push(res)
            }
        })
    }

    @computed
    get filteredFileByCompanyId() {
        let filteredFileByCompanyId = this.mediaData
        if (this.companyId) {
            filteredFileByCompanyId = filteredFileByCompanyId.filter(p => p.companyId == this.companyId || !p.companyId)
        }

        return filteredFileByCompanyId
    }
}
export default new MediaStore()
